// extracted by mini-css-extract-plugin
export var wrap = "ContentsWrap-module--wrap--63482";